import { TariffGroupAttribute, TariffGroupAttributeTypeEnum } from '@src/core/buyerApiClient';

import type { LanguageOption } from '@src/domains/products/features/product-booking/types/language';
import { getLanguageOptionMeta } from '@src/domains/products/features/product-booking/core/language/getLanguageOptionMeta';

export const buildLanguageOptions = (attributes: TariffGroupAttribute[]): LanguageOption[] => {
  const seen = new Set<string>();
  const options: LanguageOption[] = [];

  for (const attribute of attributes) {
    if (attribute.deletedAt || attribute.type !== TariffGroupAttributeTypeEnum.Language) {
      continue;
    }

    const value = attribute.value.trim();
    if (!value || seen.has(value)) {
      continue;
    }

    seen.add(value);
    const meta = getLanguageOptionMeta(value);

    options.push({
      value,
      label: meta.label,
      flagCode: meta.flagCode,
    });
  }

  return options;
};
